import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { CheckCircle } from 'lucide-react';

const B2B_IMAGE =
  'https://customer-assets.emergentagent.com/job_text-pdf-engine/artifacts/1e759rgy_freepik__un-chef-con-delantal-impecable-colocando-con-pinza__52051.png';

const WHATSAPP_NUMBER = '34690808995';

const benefits = [
  'Precio especial por volumen y condiciones negociadas',
  'Carta en PDF con ficha técnica y alérgenos completa',
  'Producción bajo demanda, entrega coordinada',
  'Fritura artesanal en aceite de oliva: temperatura precisa, dorado homogéneo y panko crujiente. Sin freidora industrial, sin aceite industrial.',
  'Porcionado uniforme y presentación perfecta en el plato',
  'El Sistema Cuadrado: consistencia que necesita un profesional',
];

const B2BSection = () => {
  const openB2BWhatsApp = () => {
    const msg =
      '¡Hola María! Soy del sector profesional (restaurante/catering) y me interesa conocer las condiciones y carta para profesionales del Sistema Cuadrado.';
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`,
      '_blank'
    );
  };

  return (
    <section
      id="b2b"
      data-testid="b2b-section"
      className="py-20 md:py-32 bg-[#2C2C2A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          {/* Image */}
          <div className="order-2 md:order-1">
            <div className="aspect-[4/3] overflow-hidden relative">
              <img
                src={B2B_IMAGE}
                alt="Cocina profesional"
                className="w-full h-full object-cover"
              />
              {/* Dorado overlay corner */}
              <div className="absolute top-0 right-0 w-16 h-16 bg-[#D4A853]" />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 md:order-2">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4A853] mb-4">
              Área Profesionales
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl font-bold text-white leading-tight mb-5">
              El Sistema
              <br />
              Cuadrado
              <br />
              <span className="text-[#D4A853]">para tu Negocio</span>
            </h2>
            <p className="text-white/65 mb-8 leading-relaxed text-base">
              Ingredientes de primera calidad, elaborados a mano. Con la
              consistencia que necesita un profesional sin perder ni un gramo
              de sabor casero.
            </p>

            <ul className="space-y-3 mb-10">
              {benefits.map((benefit, i) => (
                <li key={i} className="flex items-start gap-3 text-white/75 text-sm">
                  <CheckCircle
                    size={15}
                    className="text-[#D4A853] mt-0.5 flex-shrink-0"
                  />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>

            <button
              data-testid="b2b-whatsapp-button"
              onClick={openB2BWhatsApp}
              className="flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-[#1DA851] transition-all duration-300 rounded-none"
            >
              <FaWhatsapp size={20} />
              Contactar para B2B
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default B2BSection;
